<template>
  <div v-cloak @drop.prevent="addDropFile" @dragover.prevent>
    <form ref="fileInput">
      <v-file-input
        class="fileupload"
        ref="inputUpload"
        name="attachment"
        :placeholder="$t('documents.dropFileHere')"
        prepend-icon=""
        prepend-inner-icon="mdi-paperclip"
        lable="Upload file"
        :rules="rules"
        :accept="accept"
        :disabled="disabled"
        :multiple="multiple"
        outlined
        dense
        @change="addFiles"
        :hide-details="hideDetails"
        @click:prepend-inner="iconClickable"
      >
      </v-file-input>
    </form>
    <v-divider v-if="listItems.length"></v-divider>
    <v-list two-line dense v-if="listItems.length" class="file-list">
      <v-list-item
        v-for="(file, index) in listItems"
        :key="index"
        link
        :class="[
          checkStatus(file).status !== true ? 'v-list-item--active' : '',
        ]"
        :color="checkStatus(file).status !== true ? '#990000' : ''"
      >
        <v-list-item-avatar>
          <v-icon class="mdi-36px" color="grey lighten-1">
            {{ icons[file.extension] || "mdi-file" }}
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title> {{ file.fileName }} </v-list-item-title>
          <v-list-item-subtitle style="line-height: 18px !important;"
            >{{ formatBytes(file.size) }} -
            {{ file.type }}</v-list-item-subtitle
          >
          <v-list-item-subtitle v-if="chunkUpload">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-checkbox
                    :label="$t('documents.lblLargeFileUpload')"
                    dense
                    hide-details
                    class="chk-hunk-upload ml-0 mt-0 pt-0"
                    :ripple="false"
                    v-model="file.chunk_upload"
                    @change="onChunkUploadChange($event, file.fileName)"
                  ></v-checkbox>
                </span>  
              </template>
              <span>{{ $t("agenda.tipLargeFileUpload") }}</span>
            </v-tooltip>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action v-if="checkStatus(file).status !== true">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="#990000 lighten-1" dark v-bind="attrs" v-on="on">
                mdi-alert
              </v-icon>
            </template>
            <span>{{ checkStatus(file).message }}</span>
          </v-tooltip>
        </v-list-item-action>

        <v-list-item-action>
          <v-btn icon @click="remove(index, file.fileName)">
            <v-icon
              :color="
                checkStatus(file).status == true
                  ? 'grey lighten-1'
                  : 'error lighten-1'
              "
              >mdi-close</v-icon
            >
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
const imageMimeTypes = ["image/png", "image/jpeg"];
import { formatBytes, currentDateTime } from "../../utils/util";
import { MAX_UPLOAD_SIZE } from "../../utils/constant";

export default {
  name: "UploadFile",
  props: {
    files: { type: Array, default: () => [] },
    icons: Object,
    clearList: Boolean,
    rules: Array,
    accept: Array,
    disabled: { Type: Boolean, default: false },
    maxsize: { Type: Number, default: MAX_UPLOAD_SIZE },
    hideDetails: { Type: Boolean, default: false },
    multiple: { Type: Boolean, default: true },
    chunkUploadFilesList: { Type: Array, default: () => [] },
    chunkUpload: { Type: Boolean, default: false },
  },
  data() {
    return {
      listItems: [],
    };
  },
  computed: {},
  watch: {
    clearList: {
      immediate: true,
      async handler() {
        this.listItems = [];
      },
    },
    files: {
      deep: true,
      immediate: true,
      async handler() {
        this.listItems = await this.filesMap(this.files);
      },
    },
  },
  methods: {
    formatBytes,
    filesMap,
    addFiles,
    remove,
    onChunkUploadChange,
    checkStatus(file) {
      const maxSize = this.maxsize ?? 0;
      let filesWithStatus = {
        filename: file.fileName,
      };
      if (!this.accept.includes(file.type)) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileErrorMsg", {
          filename: file.fileName,
        });
      } else if (file.size > maxSize) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileSizeErrorMsg", {
          maxsize: formatBytes(maxSize),
        });
      } else {
        filesWithStatus.status = true;
        filesWithStatus.message = "Success";
      }

      return filesWithStatus;
    },
    async addDropFile(e) {
      Array.from(e.dataTransfer.files).forEach((file) => {
        // this.files.push(file);
        this.$emit("add-files", [file]);
      });
    },
    iconClickable() {
      this.$refs.inputUpload.$el.querySelector("input").click();
    },
  },
};

function remove(index, fileName) {
  this.$emit("remove-file", index);
  this.$emit("chunk-upload", { isChunkUpload: false, fileName });
  this.listItems.splice(index, 1);
  this.$refs.inputUpload.reset();
}

async function filesMap(files) {
  let promises = Array.from(files).map((file) => {
    let result = {
      fileName: file.name,
      type: file.type,
      size: file.size,
      lastModified: currentDateTime(file.lastModified),
      extension: file.name.split(".").pop(),
      chunk_upload: this.chunkUploadFilesList.some(
        (item) => item.fileName === file.name && item.isChunkUpload === true
      ),
    };
    return new Promise((resolve) => {
      if (!imageMimeTypes.includes(result.type) || file.documentId) {
        return resolve(result);
      }
      let reader = new FileReader();
      reader.onload = function (e) {
        result.preview = e.target.result;
        resolve(result);
      };
      reader.readAsDataURL(file);
    });
  });
  return await Promise.all(promises);
}

function addFiles(files) {
  if (files && files.length > 0 && this.multiple) {
    this.$emit("add-files", files);
    this.$refs.inputUpload.reset();
    this.$refs.fileInput.reset();
  } else if (files && files.name) {
    this.$emit("add-files", [files]);
    this.$refs.inputUpload.reset();
    this.$refs.fileInput.reset();
  }
}

function onChunkUploadChange(value, fileName) {
  this.$emit("chunk-upload", { isChunkUpload: value, fileName });
}
</script>

<style scoped>
::v-deep .fileupload {
  padding-top: 0 !important;
  margin-top: 0 !important;
  color: #990000 !important;
}
::v-deep.v-text-field--outlined .v-input__slot {
  border: dashed 1px var(--v-neutralGray1-base) !important;
}
::v-deep.v-text-field--outlined fieldset {
  border: none;
}

.chk-hunk-upload {
  margin-left: -3px !important;
}

::v-deep .chk-hunk-upload.v-input .v-label {
  font-size: 13px !important;
}

::v-deep .chk-hunk-upload.v-input .v-input--selection-controls__input {
  margin-right: 2px !important;
}
</style>